import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import instance from '../../src/api/axiosInstance';
import Sidebar from '../components/Sidebar';
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import '../css/Dashboard.css';
import API_BASE_URL from '../api';

const DashboardCVStats = () => {
  const navigate = useNavigate();
  const [cvStats, setCvStats] = useState({
    total: 0,
    latestFile: '',
    latestDate: '',
    templates: [],
    user: {
      total: 0,
      latestFile: '',
      latestDate: ''
    }
  });

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchStats = async () => {
      try {
      const res = await instance.get('/cvs/stats');

        setCvStats(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement des statistiques :", err);
        if (err.response?.status === 401 || err.response?.status === 403) {
          localStorage.clear();
          navigate('/login');
        }
      }
    };

    fetchStats();
  }, [navigate]);

  return (
    <Box className="cvstats-layout">
      <Sidebar />
      <Box className="cvstats-content">
        <Typography variant="h5" className="cvstats-title">
          📊 Statistiques CV Parsing
        </Typography>

        <Grid container spacing={3} className="cvstats-grid">
          {/* Stat global */}
          <Grid item xs={12} md={3}>
            <Paper className="cvstats-card" elevation={2}>
              <Typography variant="subtitle1">Total de CVs parsés</Typography>
              <Typography variant="h6">{cvStats.total}</Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={3}>
            <Paper className="cvstats-card" elevation={2}>
              <Typography variant="subtitle1">Dernier fichier</Typography>
              <Typography>{cvStats.latestFile || '—'}</Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={3}>
            <Paper className="cvstats-card" elevation={2}>
              <Typography variant="subtitle1">Dernière date</Typography>
              <Typography>
                {cvStats.latestDate
                  ? new Date(cvStats.latestDate).toLocaleString()
                  : '—'}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={3}>
            <Paper className="cvstats-card" elevation={2}>
              <Typography variant="subtitle1">Templates utilisés</Typography>
              <List dense>
                {cvStats.templates.map((tpl, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemText primary={`${tpl.template} : ${tpl.count}`} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>

          {/* Stat utilisateur connecté */}
          <Grid item xs={12} md={6}>
            <Paper className="cvstats-card" elevation={2}>
              <Typography variant="subtitle1">Vos CVs parsés</Typography>
              <Typography variant="h6">{cvStats.user?.total ?? 0}</Typography>
              <Typography variant="body2">
                Dernier : {cvStats.user?.latestFile || '—'}<br />
                Date : {cvStats.user?.latestDate
                  ? new Date(cvStats.user.latestDate).toLocaleString()
                  : '—'}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DashboardCVStats;
